module.exports = __webpack_public_path__ + "static/media/Virtualizado3_AcercaDe_1024.0f15290f.png";